module.exports = __webpack_public_path__ + "img/pipe-6.4e2cdde8.jpg";